module.exports = __webpack_public_path__ + "icon-private-offer.3257377618cb398f5f90.svg";